import { render, staticRenderFns } from "./wtCheckbox.component.vue?vue&type=template&id=ea482f5e&"
import script from "./wtCheckbox.component.vue?vue&type=script&lang=js&"
export * from "./wtCheckbox.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports